/**
 * 通用附件上传表单项：由父组件提供 customRequest（通常走 OSS 凭证 + ossUpload）。
 */
import { DeleteOutlined, InboxOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Space, Upload } from 'antd';
import type { UploadProps } from 'antd';
import React from 'react';

type FileUploadFieldProps = {
  accept?: string;
  customRequest: NonNullable<UploadProps['customRequest']>;
  hint?: string;
  limit?: number;
  onChange: (next: string[]) => void;
  uploading?: boolean;
  uploadingText: string;
  uploadText: string;
  value?: string[];
};

function resolveFileName(fileUrl: string, index: number) {
  const [path] = fileUrl.split('?');
  const rawName = path.split('/').pop() || `attachment-${index + 1}`;
  try {
    return decodeURIComponent(rawName);
  } catch {
    return rawName;
  }
}

const FileUploadField: React.FC<FileUploadFieldProps> = ({
  accept,
  customRequest,
  hint,
  limit,
  onChange,
  uploading,
  uploadingText,
  uploadText,
  value,
}) => {
  const fileUrls = (value || []).filter(Boolean);
  const uploadDisabled = uploading || (typeof limit === 'number' && fileUrls.length >= limit);

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      {fileUrls.length ? (
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {fileUrls.map((fileUrl, index) => (
            <Space
              key={fileUrl}
              style={{
                width: '100%',
                justifyContent: 'space-between',
                padding: '8px 12px',
                border: '1px solid #f0f0f0',
                borderRadius: 8,
              }}
            >
              <Space size={8}>
                <PaperClipOutlined />
                <a href={fileUrl} rel='noreferrer' target='_blank'>
                  {resolveFileName(fileUrl, index)}
                </a>
              </Space>
              <Button
                danger
                icon={<DeleteOutlined />}
                size='small'
                type='text'
                onClick={() => onChange(fileUrls.filter((_, itemIndex) => itemIndex !== index))}
              />
            </Space>
          ))}
        </Space>
      ) : null}
      {typeof limit === 'number' && fileUrls.length >= limit ? null : (
        <Upload.Dragger
          accept={accept}
          customRequest={customRequest}
          disabled={uploadDisabled}
          multiple
          showUploadList={false}
        >
          <p className='ant-upload-drag-icon'>
            <InboxOutlined />
          </p>
          <p className='ant-upload-text'>{uploading ? uploadingText : uploadText}</p>
          {hint ? <p className='ant-upload-hint'>{hint}</p> : null}
        </Upload.Dragger>
      )}
    </Space>
  );
};

export default FileUploadField;
